exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".infoAsync{background-color:#eee;padding:10px 0;margin-bottom:10px;text-align:center;justify-content:center}.infoAsync,.infoAsync p{display:flex;align-items:center}.infoAsync p{margin:0}.spinner-load{width:50px;height:50px;margin-right:10px}.list-item{list-style:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fb89a88","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/detenteur/ListeDetenteurs.vue
// module id = 619
// module chunks = 0